import { gql } from '@grandvisionhq/graphql';
import { failureFragment } from './get-shopping-list-by-id-product.js';

var GET_SHOPPING_LIST_COUNT = gql`
  query GetShoppingListCount($shoppinglistId: String!) {
    shoppinglistById(shoppinglistId: $shoppinglistId) {
      shoppinglist {
        itemsCount
      }
      failure {
        ...ShoppinglistFailureFragment
      }
    }
  }
  ${failureFragment}
`;

export { GET_SHOPPING_LIST_COUNT as default };
//# sourceMappingURL=get-shopping-list-count.js.map
